import {FeatureFlagType} from '../PlanModel/enum/FeatureFlagType'
import {PermissionType} from './enum/PermissionType'

const PLAN_CAP_PERMISSION_TYPE_BY_FEATURE_FLAG_TYPE: Partial<Record<FeatureFlagType, PermissionType>> = {
  [FeatureFlagType.TableDatabaseView]: PermissionType.planCapDatabaseViewTable,
  [FeatureFlagType.MapDatabaseView]: PermissionType.planCapDatabaseViewMap,
  [FeatureFlagType.FormDatabaseView]: PermissionType.planCapDatabaseViewForm,
  [FeatureFlagType.TimelineDatabaseView]: PermissionType.planCapDatabaseViewTimeline,
  [FeatureFlagType.CalendarDatabaseView]: PermissionType.planCapDatabaseViewCalendar,
  [FeatureFlagType.KanbanDatabaseView]: PermissionType.planCapDatabaseViewKanban,
  [FeatureFlagType.IFrameDatabaseView]: PermissionType.planCapDatabaseViewIframe,
  [FeatureFlagType.GanttDatabaseView]: PermissionType.planCapDatabaseViewGantt,
  [FeatureFlagType.ChartDashboardItem]: PermissionType.planCapDashboardItemChart,
  [FeatureFlagType.DatabaseViewDashboardItem]: PermissionType.planCapDashboardItemDatabaseView,
  [FeatureFlagType.TimeTrackerDashboardItem]: PermissionType.planCapDashboardItemTimeTracker,
  [FeatureFlagType.MapDashboardItem]: PermissionType.planCapDashboardItemMap,
  [FeatureFlagType.AggregatedDatabaseItemListDashboardItem]: PermissionType.planCapDashboardItemAggregatedItemList,
  [FeatureFlagType.IndicatorDashboardItem]: PermissionType.planCapDashboardItemIndicator,
}

export const PLAN_CAP_PERMISSION_TYPES = Object.values(PLAN_CAP_PERMISSION_TYPE_BY_FEATURE_FLAG_TYPE) as PermissionType[]

export function getPlanCapPermissionType(featureFlagType: FeatureFlagType): PermissionType | null {
  return PLAN_CAP_PERMISSION_TYPE_BY_FEATURE_FLAG_TYPE[featureFlagType] ?? null
}

export function getFeatureFlagTypeForPlanCapPermissionType(permissionType: PermissionType): FeatureFlagType | null {
  for (const [featureFlagType, planCapPermissionType] of Object.entries(PLAN_CAP_PERMISSION_TYPE_BY_FEATURE_FLAG_TYPE)) {
    if (planCapPermissionType === permissionType) {
      return featureFlagType as FeatureFlagType
    }
  }
  return null
}
